import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import SideBar from "../elements/sidebar";
import "../styles/aisearch.css";
import { useGetsolveMyQueryQuery } from "../store/General/generalSlice";
import { getAchievementSrc, GetBadgeName } from "../components/helpers";
import handleDownload from "../components/helpers";
import HomemainHeader from "../components/homemainheader";
import { useGetUserScoreQuery } from "../store/caseSimulation/CaseStudyApiSlice";
import { IoCamera } from "react-icons/io5";
import BreadCrumb from "../elements/breadcrumb";
import {
  useSolveMyQueryMutation,
  useBookmarkQueryMutation,
  usePostResponseFeedbackMutation,
} from "../store/General/generalSlice";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { BiLoaderCircle } from "react-icons/bi";
import config from "../config/APIEndpoints";
import HomemainHeaderMobile from "../components/homemainheadermobile";
import { useGetAiHisotryQuery } from "../store/General/generalSlice";
import LoadingScreen from "../elements/loading";
import { useGetProfileQuery } from "../store/profile/UserApiSlice";
import SharePopup from "../elements/share";
import ScoreBoardBanner from "../components/scoreboardbanner";
import Footer from "../elements/footer";
const UserIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";
const GripLine =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/griplinessidebar.svg";
const headerbadge =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/headerbadge.svg";
const fireicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/fire.svg";
const reloadicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/reload.svg";
const DotsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/dots.svg";
const ThumbsUpSelected =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/thumbsupblue.svg";
const ThumbsDownSelect =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/thumbsdownblue.svg";
const ThumbsUp =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/dashboard/thumbsup.svg";
const ThumbsDown =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/dashboard/thumbsdown.svg";
const OpenIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/open.svg";
const CloseIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/close.svg";
const bookmarkNotSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/bookmarknotselected.svg";
const bookmarkIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/bookmark.svg";
const UploadIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/inputcamera.svg";
const micIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/inputmic.svg";

const crossIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/crossiconblue.svg";
const ProfileIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profile.svg";
const convertUTCtoIST = (utcDate) => {
  const date = new Date(utcDate); // Convert string to Date object
  return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
};
export default function AiSearch() {
  const { data: profileData } = useGetProfileQuery();
  const { data: quarydata } = useGetAiHisotryQuery();

  const [isShareOpen, setisShareOpen] = useState(false);
  const [bookmark, setBookmark] = useState(false);
  const { uid } = useParams();
  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    window.innerWidth < 1000 ? true : false
  );
  const navigate = useNavigate();
  const [fileName, setFileName] = useState("Upload Here");
  const [file, setFile] = useState(null);
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name);
      setFile(selectedFile);
    }
  };
  const { data, isLoading } = useGetsolveMyQueryQuery(uid);
  const { data: score, isLoading: scoreloading } = useGetUserScoreQuery(uid);
  const [query, setquery] = useState();
  const [getquery, getquerystate] = useSolveMyQueryMutation();
  const [bookmarkresult, bookmarkresultstate] = useBookmarkQueryMutation();
  const downref = useRef();
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.lang = "en-US";
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onresult = (event) => {
        const spokenText = event.results[0][0].transcript;
        setquery((prevQuery) => `${prevQuery} ${spokenText}`);
        setIsListening(false);
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error:", event.error);
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    } else {
      console.warn("Speech recognition not supported in this browser.");
    }
  }, []);

  const startListening = () => {
    if (recognitionRef.current) {
      setIsListening(true);
      recognitionRef.current.start();
    }
  };
  const handleSearch = async () => {
    if (!query) {
      toast.warning("please enter Query!");
      return;
    }
    const formData = new FormData();
    formData.append("query", query);
    if (file) formData.append("file_uploads", file);

    const resp = await getquery(formData);
    if (resp?.error) {
      const utcDate = resp?.error?.data?.next;
      const istDate = convertUTCtoIST(utcDate);
      toast.error(
        <div>
          <p>
            {resp?.error?.data?.error} please try after {istDate}!
          </p>
          <b>Or</b>{" "}
          <div>
            {" "}
            <p>
              Upgrade your plan at just{" "}
              <a
                style={{ color: "#0090ff" }}
                onClick={() => {
                  navigate("/profile?page=membership");
                }}
              >
                Rs 99
              </a>
            </p>
          </div>
        </div>
      );
    } else {
      navigate(`/aisearch/${resp.data.uuid}`);
    }
  };
  useEffect(() => {
    setBookmark(data?.data?.bookmark);
    setquery(data?.data?.query);
  }, [data]);
  const toggleShare = () => {
    setisShareOpen(!isShareOpen);
  };
  const [isScoreboardVisible, setIsScoreboardVisible] = useState(false);
  const toggleScoreboard = () => {
    setIsScoreboardVisible(!isScoreboardVisible);
  };
  const [isEditable, setIsEditable] = useState(true);
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [
    postResponseFeedback,
    { error: feedbackError, isSuccess: feedbacksuceess },
  ] = usePostResponseFeedbackMutation();
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    if (downloading == true) {
      setTimeout(() => {
        setDownloading(false);
      }, 2000);
    }
  }, [downloading]);
  useEffect(() => {
    if (feedbackError) {
      toast.error("Error sending feedback");
    } else if (feedbacksuceess) {
      toast.info("Feedback sent successfully");
    }
  }, [feedbackError, feedbacksuceess]);
  console.log(data);
  useLayoutEffect(() => {
    if (data) {
      const feedbackValue =
        data.data?.feedback === true
          ? "positive"
          : data.data?.feedback === false
          ? "negative"
          : null;
      setSelectedFeedback(feedbackValue);
      console.log("Setting Selected Feedback to:", feedbackValue);
    }
  }, [data]);

  const handleFeedback = async (response) => {
    try {
      await postResponseFeedback({
        view_name: "InMind",
        uuid: data?.data?.uuid,
        response,
      });
      setSelectedFeedback(response ? "positive" : "negative");
    } catch (error) {
      console.error("Error sending feedback:", error);
    }
  };

  const feedbackIcons = {
    positive: selectedFeedback === "positive" ? ThumbsUpSelected : ThumbsUp,
    negative: selectedFeedback === "negative" ? ThumbsDownSelect : ThumbsDown,
  };
  console.log({ quarydata });
  return (
    <div className="homemain">
      <SideBar
        selected="Dashboard"
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebar}
      />
      {isShareOpen ? (
        <SharePopup
          onClose={toggleShare}
          isVisible={isShareOpen}
          inputvalue={window.location.href}
        />
      ) : null}

      <div
        className="homeright"
        style={{
          marginLeft: isSidebarCollapsed ? "110px" : "370px",
        }}
      >
        <HomemainHeader
          onToggle={toggleSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
        />
        <BreadCrumb element="Search" />
        <div className="dashboardbody">
          <div className="dashboardheader aisearchheader">
            <h2>What's on your mind?</h2>
            <p>
              Example: How do Proteosome Inhibitors function in the treatment of
              Multiple Myeloma?
            </p>
            <div
              className={`dashboardinput ${
                query ? "border-blue-500 shadow-blue" : "border-gray-300"
              }`}
              style={{
                borderWidth: "2px",
                borderRadius: "8px",
                padding: "10px",
                boxShadow: query
                  ? "0px 4px 10px 4px rgba(0, 144, 255, 0.13);"
                  : "none",
              }}
            >
              <input
                type="text"
                value={query || ""}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                disabled={getquerystate?.isLoading}
                onChange={(e) => setquery(e.target.value)}
                placeholder="Enter your question here"
              />
              {getquerystate?.isLoading ? (
                <BiLoaderCircle className="animate-spin" />
              ) : (
                <div className="flex flex-row gap-4 inputimagesrow">
                  {query && (
                    <img
                      src={crossIcon}
                      alt="Clear"
                      onClick={() => setquery("")}
                    />
                  )}

                  <div className="tooltip-container">
                    <input
                      type="file"
                      id="file"
                      accept=".pdf, image/*"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="file" style={{ cursor: "pointer" }}>
                      {file ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt="Uploaded File"
                          width="50"
                        />
                      ) : (
                        <IoCamera className="uploadiconcamera" />
                      )}
                    </label>
                    {/* <div className="tooltip-image">
                      <div className="bottomtriangle"></div>
                      Upload File
                    </div> */}
                  </div>
                  {/* <div className="tooltip-container" onClick={startListening}>
                    <img src={micIcon} alt="Mic" />
                    <div className="tooltip-image">
                      <div className="bottomtriangle"></div>
                      Use Voice
                    </div>
                  </div> */}
                </div>
              )}
            </div>
          </div>
          <div className="dashboardbodyelements">
            <div className="flex flex-wrap w-full"></div>
            <div className="aisearchheaderbody">
              <div className="aisearchheaderbodyleft">
                <h2>Results</h2>
              </div>

              <div className="aisearchbodyright">
                <div
                  className="elementselector bookmarkselector"
                  onClick={() => {
                    setBookmark(!bookmark);
                    bookmarkresult(uid);
                  }}
                >
                  {bookmark ? (
                    <img src={bookmarkIcon} alt="Bookmark" />
                  ) : (
                    <img src={bookmarkNotSelectedIcon} alt="Bookmark" />
                  )}
                </div>
                <button
                  onClick={() => {
                    handleDownload(downref);
                    setDownloading(true);
                  }}
                  className="elementselector"
                >
                  {downloading ? <p>Downloading..</p> : <p>Download</p>}
                </button>
                <div className="elementselector" onClick={toggleShare}>
                  Share
                </div>
              </div>
            </div>
            <hr />
            {data?.data?.files?.map((rec) => (
              <img
                style={{
                  maxHeight: "10rem",
                  borderRadius: "1rem",
                  marginTop: "1rem",
                }}
                src={`${config.getEndpoint()}${rec?.file}`}
              />
            ))}
            <div
              className="dashboardbodycontent"
              ref={downref}
              dangerouslySetInnerHTML={{
                __html: data?.data?.result,
              }}
            ></div>
            <p className="bettersearchexperience">
              **For better image analysis, upload good quality images**
            </p>
            <div className="dashboardresponsefeedback">
              <p>Do you like the Response?</p>
              <img
                src={feedbackIcons.positive}
                alt="Thumbs Up"
                onClick={() => handleFeedback(true)}
                style={{ cursor: "pointer" }}
              />
              <img
                src={feedbackIcons.negative}
                alt="Thumbs Down"
                onClick={() => handleFeedback(false)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <p className="usagewarning">
            This is intended for educational purpose only!
          </p>
        </div>
        <div className="historyelement bg-white mt-5 ">
          <div className="historyelementheader rowalign">
            <div className="historyelementleft">
              <h2>Previous Search</h2>
            </div>
            <div className="historyelementright">
              <button
                className="elementselector"
                onClick={() => {
                  navigate("/profile?page=history");
                }}
              >
                View all
              </button>
            </div>
          </div>
          <hr />

          <div className="searchresulthistory">
            {quarydata
              ?.slice(-5)
              .reverse()
              .map((rec) => (
                <p key={rec.id}>{rec?.query}</p>
              ))}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
